import React, { useCallback, useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font, pdf } from '@react-pdf/renderer';
import regular from '../../../assets/fonts/Montserrat/Montserrat-Regular.ttf';
import bold from '../../../assets/fonts/Montserrat/Montserrat-Bold.ttf';
import semibold from '../../../assets/fonts/Montserrat/Montserrat-SemiBold.ttf';
import medium from '../../../assets/fonts/Montserrat/Montserrat-Medium.ttf';
// import { getImageToken } from '../../../helpers/file_manager/backend_helper';
import { downloadFile as onDownloadFile } from '../../../slices/thunks';
import dayjs from 'dayjs';
import { upperCase } from 'lodash';

// Font.register({
//     family: 'Montserrat',
//     fonts: [
//         { src: regular, fontWeight: 'normal' },
//         { src: bold, fontWeight: 'bold' },
//         { src: semibold, fontWeight: '600' },
//         { src: medium, fontWeight: '500' },
//     ],
// });

const Table = ({ headers, data, additionalStylesTable, additionalStylesHeaders, additionalStylesCell, contentColumnIndex, withoutBorderSeparator, noBorders }) => {
    return (
        <View
            style={
                [
                    [
                        styles.table,
                        noBorders
                            ? styles.noBorderTable
                            : null
                    ],
                    ...[additionalStylesTable]
                ]
            }
        >
            ({
                headers ?
                    (
                        <View style={[styles.row]}>
                            {headers.map((header, index) => (
                                <Text
                                    key={index}
                                    style={[
                                        [
                                            styles.cell,
                                            styles.headerCell,
                                            index === 0
                                                ? styles.firstCell
                                                : null
                                        ],
                                        ...[additionalStylesHeaders[index]]
                                    ]}
                                >
                                    {header.name}
                                </Text>
                            ))}
                        </View>
                    ) : null
            })
            {data.map((row, indexRow) => (
                <View
                    key={indexRow}
                    style={styles.row}
                >
                    {(
                        Object.values(row).map((item, indexCell) => (
                            (!React.isValidElement(item) ?
                                <Text
                                    key={indexCell}
                                    style={[
                                        [
                                            styles.cell,
                                            indexCell === 0
                                                ? styles.firstCell
                                                : null,
                                            !headers && indexRow === 0
                                                ? styles.firstCellWithoutHeader
                                                : null,
                                            withoutBorderSeparator
                                                ? styles.cellWithoutBorderLeft
                                                : null,
                                            noBorders
                                                ? styles.noBorderCell
                                                : null
                                        ],
                                        ...[additionalStylesCell[indexCell]]
                                    ]}
                                >
                                    {item}
                                </Text>
                                : <View style={[
                                    [
                                        styles.cell,
                                        { width: '100%', padding: 0 },
                                        indexCell === 0
                                            ? styles.firstCell
                                            : null,
                                        !headers && indexRow === 0
                                            ? styles.firstCellWithoutHeader
                                            : null,
                                        withoutBorderSeparator
                                            ? styles.cellWithoutBorderLeft
                                            : null,
                                        noBorders
                                            ? styles.noBorderCell
                                            : null
                                    ],
                                    ...[additionalStylesCell[indexCell]]
                                ]}>{item}</View>
                            )
                        )
                        ))}
                </View>
            ))}
        </View>
    );
}

const PageDeliverySignatureTemplate = ({ data }) => {
    return (
        <View style={styles.footer} fixed>
            <View style={
                {
                    fontSize: 11,
                    padding: '10px 45px 160px 45px',
                }
            }>

                <View>
                    <Text
                        style={{
                            fontSize: 11,
                            padding: '15px 4px 0 4px',
                            lineHeight: 2,
                            textAlign: 'justify'
                        }}
                    >
                        ENTREGA
                    </Text>
                </View>
                <Table
                    headers={[
                        { name: 'Nombre' },
                        { name: 'RUN' },
                        { name: 'Fecha de Entrega' },
                        { name: 'Firma' },
                    ]}
                    additionalStylesHeaders={[
                        [{
                            backgroundColor: '#F2F2F2',
                            flex: 1,
                        }],
                        [{
                            flex: 0,
                            minWidth: 100,
                            backgroundColor: '#F2F2F2',
                            textAlign: 'center'
                        }],
                        [{
                            flex: 0,
                            minWidth: 100,
                            backgroundColor: '#F2F2F2',
                            textAlign: 'center'
                        }],
                        [{
                            flex: 0,
                            minWidth: 150,
                            backgroundColor: '#F2F2F2',
                            textAlign: 'center'
                        }],
                    ]}
                    additionalStylesCell={[
                        [{
                            flex: 1,
                            height: 50,
                            textAlign: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }],
                        [{
                            flex: 0,
                            textAlign: 'center',
                            height: 50,
                            minWidth: 100,
                            justifyContent: 'center',
                            alignItems: 'center',
                        }],
                        [{
                            flex: 0,
                            textAlign: 'center',
                            height: 50,
                            minWidth: 100,
                        }],
                        [{
                            flex: 0,
                            textAlign: 'center',
                            height: 50,
                            minWidth: 150,
                        }],
                    ]}
                    data={[[data?.delivery_person?.name, data?.delivery_person?.rut, null, null]]}
                />
            </View>
        </View>
    )
}

const PageReceptionSignatureTemplate = ({ data }) => {
    return (
        <View style={styles.footer} fixed>
            <View style={
                {
                    fontSize: 11,
                    padding: '10px 45px 60px 45px',
                }
            }>

                <View>
                    <Text
                        style={{
                            fontSize: 11,
                            padding: '15px 4px 0 4px',
                            lineHeight: 2,
                            textAlign: 'justify'
                        }}
                    >
                        RECIBE
                    </Text>
                </View>


                <Table
                    headers={[
                        { name: 'Nombre' },
                        { name: 'RUN' },
                        { name: 'Fecha de Recepción' },
                        { name: 'Firma' },
                    ]}
                    additionalStylesHeaders={[
                        [{
                            backgroundColor: '#F2F2F2',
                            flex: 1,
                        }],
                        [{
                            flex: 0,
                            minWidth: 100,
                            backgroundColor: '#F2F2F2',
                            textAlign: 'center'
                        }],
                        [{
                            flex: 0,
                            minWidth: 100,
                            backgroundColor: '#F2F2F2',
                            textAlign: 'center'
                        }],
                        [{
                            flex: 0,
                            minWidth: 150,
                            backgroundColor: '#F2F2F2',
                            textAlign: 'center'
                        }],
                    ]}
                    additionalStylesCell={[
                        [{
                            flex: 1,
                            height: 50,
                            textAlign: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }],
                        [{
                            flex: 0,
                            textAlign: 'center',
                            height: 50,
                            minWidth: 100,
                            justifyContent: 'center',
                            alignItems: 'center',
                        }],
                        [{
                            flex: 0,
                            textAlign: 'center',
                            height: 50,
                            minWidth: 100,
                        }],
                        [{
                            flex: 0,
                            textAlign: 'center',
                            height: 50,
                            minWidth: 150,
                        }],
                    ]}
                    data={[[data?.person?.name, data?.person?.rut, null, null]]}
                />
            </View>
        </View>
    )
}

const PageFooterTemplate = (render) => {
    return (
        <View style={styles.footer} fixed>
            <View style={
                {
                    padding: '10px 45px 35px 45px',
                }
            }>
                <Table
                    additionalStylesTable={[
                        {
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            borderRightWidth: 0,
                            padding: 0,
                            margin: 0
                        }
                    ]}
                    additionalStylesHeaders={[
                        [{
                            flex: 1,
                        }],
                    ]}
                    additionalStylesCell={
                        [
                            [
                                {
                                    flex: 0,
                                    minWidth: 50,
                                    textAlign: 'left'
                                }
                            ],
                            [
                                {
                                    flex: 1,
                                    textAlign: 'right'
                                }
                            ],
                        ]
                    }
                    withoutBorderSeparator={false}
                    data={[
                        [
                            <View style={{ padding: '2px 4px 2px 4px' }}>
                                <Text style={{ fontSize: 8, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (
                                    `${pageNumber}`
                                )} />
                            </View>,
                            <View style={{ padding: '2px 4px 2px 4px' }}>
                                <Text style={{ fontSize: 8, textAlign: 'left' }}>Depto. De Recursos Humanos</Text>
                            </View>,
                        ]
                    ]}
                />
            </View>
        </View>
    )
}

const DocumentTemplate = (logoSrc, data,) => {
    return (
        <Document>
            <Page style={styles.page}>
                <View style={styles.page_wrapper}>
                    <View >
                        <Table
                            withoutBorderSeparator={false}
                            additionalStylesHeaders={[
                            ]}
                            additionalStylesCell={
                                [
                                    [
                                        {
                                            flex: 0,
                                            minWidth: 140
                                        }
                                    ],
                                    [{ flex: 1 }],
                                ]
                            }
                            data={[
                                [
                                    <View
                                        style={
                                            {
                                                width: '100%',
                                                height: 55,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }
                                        }>
                                        <Image style={styles.logo} src={logoSrc} />
                                    </View>,
                                    <View style={{ width: '100%', padding: 0, margin: 0 }}>
                                        <Table
                                            additionalStylesTable={[
                                                {
                                                    borderWidth: 0,
                                                    padding: 0,
                                                    margin: 0
                                                }
                                            ]}
                                            additionalStylesHeaders={[
                                                [{
                                                    flex: 1,
                                                }],
                                            ]}
                                            additionalStylesCell={
                                                [
                                                    [{ flex: 1 }],
                                                    [{ flex: 1 }],
                                                    [{ flex: 1 }],
                                                ]
                                            }
                                            data={[
                                                [
                                                    <View
                                                        style={{
                                                            width: '100%',
                                                            padding: '10px 10px 10px 10px'
                                                        }}
                                                    >
                                                        <Text
                                                            style={
                                                                {
                                                                    fontSize: 8,
                                                                    textAlign: 'center',
                                                                    textTransform: 'uppercase'
                                                                }
                                                            }
                                                        >
                                                            REGISTRO DE ENTREGA DE EPP
                                                        </Text>
                                                    </View>
                                                ],
                                                [
                                                    <View style={{ padding: '2px 6px 10px 6px' }}>
                                                        <Text style={{ fontSize: 8 }}>Código:</Text>
                                                        <Text style={{ fontSize: 8 }}>{data.code || ''}</Text>
                                                    </View>,
                                                    <View style={{ padding: '2px 6px 10px 6px' }}>
                                                        <Text style={{ fontSize: 8 }}>Fecha de Emisión:</Text>
                                                        <Text style={{ fontSize: 8 }}>{data.generation_date || ''}</Text>
                                                    </View>,
                                                    <View style={{ padding: '2px 6px 10px 6px' }}>
                                                        <Text style={{ fontSize: 8 }}>Fecha de Modificación:</Text>
                                                        <Text style={{ fontSize: 8 }}>{data.generation_date || ''}</Text>
                                                    </View>,
                                                ]
                                            ]}
                                        />
                                    </View>
                                ],
                            ]}
                        />
                        <View
                            style={
                                {
                                    width: '100%',
                                    padding: 0,
                                    margin: 0
                                }
                            }
                        >
                            <Table
                                additionalStylesTable={[
                                    {
                                        borderTopWidth: 0,
                                        padding: 0,
                                        margin: 0
                                    }
                                ]}
                                additionalStylesHeaders={[
                                    [{
                                        flex: 1,
                                    }],
                                ]}
                                additionalStylesCell={
                                    [
                                        [
                                            {
                                                flex: 1,
                                                textAlign: 'left'
                                            }
                                        ],
                                        [
                                            {
                                                flex: 1,
                                                textAlign: 'right'
                                            }
                                        ],
                                        [
                                            {
                                                flex: 1,
                                                textAlign: 'right'
                                            }
                                        ],
                                    ]
                                }
                                withoutBorderSeparator={true}
                                data={[
                                    [
                                        <View style={{ padding: '2px 4px 2px 4px' }}>
                                            <Text style={{ fontSize: 8 }}>Aplicable a: {data.scope || ''}</Text>
                                        </View>,
                                        <View style={{ padding: '2px 4px 2px 4px' }}>
                                            <Text style={{ fontSize: 8 }}>Status: {data.status || ''}</Text>
                                        </View>,
                                        <View style={{ padding: '2px 4px 2px 4px' }}>
                                            <Text style={{ fontSize: 8 }}>Versión: {data.version || ''}</Text>
                                        </View>,
                                    ]
                                ]}
                            />
                        </View>
                    </View>
                    <View>
                        <View>
                            <Text
                                style={{
                                    fontSize: 11,
                                    padding: '15px 4px 0 4px',
                                    lineHeight: 2,
                                    textAlign: 'justify'
                                }}
                            >
                                El trabajador, Sr(a) <Text style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>{data?.person?.name || ''}</Text>, RUN <Text style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>{data?.person?.rut || 'SIN RUN'}</Text>, trabajador del
                                centro <Text style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>{data?.establishment?.name || ''}</Text> declara que recibe a su entera satisfacción los Elementos de Protección Personal
                                (EPP) que se indican más abajo, los cuales utilizará en todo momento que sean requeridos según las funciones o
                                tareas que realice. Así también reconoce y declara que la Empresa entrega los EPP señalados, sin costo alguno y
                                para el uso exclusivo de las funciones laborales del trabajador.
                            </Text>
                        </View>


                        <Table
                            headers={[
                                { name: 'Equipamiento de Protección Personal' },
                                // { name: 'Talla' },
                                { name: 'Cantidad' },
                                { name: 'Unidad' },  // Nueva columna
                            ]}
                            additionalStylesHeaders={[
                                [{
                                    backgroundColor: '#F2F2F2',
                                    flex: 1,
                                }],
                                // [{
                                //     flex: 0,
                                //     minWidth: 50,
                                //     backgroundColor: '#F2F2F2',
                                //     textAlign: 'center'
                                // }],
                                [{
                                    flex: 0,
                                    minWidth: 70,
                                    backgroundColor: '#F2F2F2',
                                    textAlign: 'center'
                                }],
                                [{
                                    flex: 0,
                                    minWidth: 70,
                                    backgroundColor: '#F2F2F2',
                                    textAlign: 'center'
                                }],
                            ]}
                            additionalStylesCell={[
                                [{
                                    flex: 1,
                                }],
                                // [{
                                //     flex: 0,
                                //     minWidth: 50,
                                //     textAlign: 'center'
                                // }],
                                [{
                                    flex: 0,
                                    minWidth: 70,
                                    textAlign: 'center'
                                }],
                                [{
                                    flex: 0,
                                    minWidth: 70,
                                    textAlign: 'center'
                                }],
                            ]}
                            data={
                                data.items.map((item) => [
                                    item.name || '',                  // Elemento de Protección Personal
                                    // item.size || '',                  // Talla
                                    item.quantity_available || '0',              // Cantidad
                                    item.unit_measurement_name.toUpperCase() || ''  // Unidad
                                ])
                            }
                        />

                    </View>
                </View>
                <PageDeliverySignatureTemplate render data={data} />

                <PageReceptionSignatureTemplate render data={data} />
                <PageFooterTemplate render />
            </Page>
        </Document>
    );
};

const styles = StyleSheet.create({
    page: {
        paddingTop: 35,
        paddingBottom: 75
    },
    page_wrapper: {
        padding: '0 48px 0 48px',
    },
    logo: {
        width: '100%',
        height: 45,
        borderStyle: 'solid',
        objectFit: 'contain',
    },
    table: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#000',
        fontSize: 10
    },
    noBorderTable: {
        borderWidth: 0
    },
    row: {
        flexDirection: 'row',
    },
    cellWithoutBorderLeft: {
        borderLeft: 0
    },
    cell: {
        padding: 3,
        borderLeftWidth: 1,
        borderTopWidth: 1,
        borderRightColor: '#000',
        borderTopColor: '#000',
        flex: 1
    },
    noBorderCell: {
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    headerCell: {
        fontWeight: 'bold',
        textAlign: 'center',
        borderTopWidth: 0
    },
    firstCell: {
        borderLeftWidth: 0
    },
    firstCellWithoutHeader: {
        borderTopWidth: 0
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 6,
        bottom: 0,
        left: 0,
        right: 0,
        padding: 20,
        textAlign: 'right',
        color: 'grey'
    },
    photographicDetail: {
        paddingTop: 10,
        paddingBottom: 10
    },
    imageWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20
    },
    image: {
        width: '80%',
        objectFit: 'contain'
    },
    footer: {
        width: '100%',
        position: 'absolute',
        bottom: 0
    },
});

export const generatePDF = async (logoSrc, data,) => {
    const documentTemplate = DocumentTemplate(logoSrc, data);
    try {
        const blob = await pdf(documentTemplate).toBlob();
        // saveAs(blob, `${name}.pdf`.toUpperCase());
        const file = new File([blob], ((data.code || '') + (('_' + data.person?.name.toUpperCase()) || '') + (('_' + data.generation_date) || '') + '.pdf'), { type: 'application/pdf' });
        return file
    } catch (error) {
        console.error("Failed to generate PDF:", error);
    }
};